import { render, staticRenderFns } from "./favoriteBtn.vue?vue&type=template&id=0cba0aca&scoped=true&"
import script from "./favoriteBtn.vue?vue&type=script&lang=js&"
export * from "./favoriteBtn.vue?vue&type=script&lang=js&"
import style0 from "./favoriteBtn.vue?vue&type=style&index=0&id=0cba0aca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba0aca",
  null
  
)

export default component.exports